import { memo, ReactNode } from 'react'
import cn from 'classnames'
import { ListCard, ListCardRow, ListCardTable, ListRow } from 'src/tailwind-components/extends/List'

interface IProps {
  className?: string
  deleteButton?: ReactNode | string
  id?: ReactNode | string
  inn?: ReactNode | string
  isMobile?: boolean
  kpp?: ReactNode | string
  name?: ReactNode | string
  onClick?: () => void
  onDeleteButtonClick?: (e: React.SyntheticEvent) => void
}

export const TableColumn = memo(function TableColumn({
  className,
  isMobile,
  name,
  id,
  inn,
  kpp,
  deleteButton,
  onDeleteButtonClick,
  onClick
}: IProps) {
  return isMobile ? (
    <ListCard
      className="shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]"
      header={name || '—'}
      headerClassName="text-title-sm text-[rgba(0,0,0,0.87)]"
      onClick={onClick}
      testId={`customer-page--list--${id}`}
    >
      <ListCardTable className={cn('grid-cols-[150px_1fr] gap-y-1')}>
        <ListCardRow
          className={cn(
            'col-end-[span_2] flex items-center pb-2 text-label-sm font-normal leading-5',
            'last:pb-0',
            'max-md:flex-col max-md:items-start max-md:leading-4'
          )}
        >
          <div className={cn('min-w-[152px] text-[rgba(0,0,0,0.54)]', 'max-md:min-w-[auto] max-md:text-label-sm')}>
            ИНН
          </div>
          <div className={cn('pl-4 text-[rgba(0,0,0,0.72)]', 'max-md:pl-0')}>{inn || '—'}</div>
        </ListCardRow>
        <ListCardRow
          className={cn(
            'col-end-[span_2] mb-0 flex items-center pb-2 text-label-sm font-normal leading-5',
            'max-md:flex-col max-md:items-start max-md:leading-4',
            'last:pb-0'
          )}
        >
          <div className={cn('min-w-[152px] text-[rgba(0,0,0,0.54)]', 'max-md:min-w-[auto] max-md:text-label-sm')}>
            КПП
          </div>
          <div className={cn('pl-4 text-[rgba(0,0,0,0.72)]', 'max-md:pl-0')}>{kpp || '—'}</div>
        </ListCardRow>
        <ListCardRow
          className={cn(
            'col-end-[span_2] mb-0 flex items-center pb-2 text-label-sm font-normal leading-5',
            'max-md:flex-col max-md:items-start max-md:leading-4',
            'last:pb-0'
          )}
        >
          {/* eslint-disable-next-line */}
          <div
            className={cn('min-w-[152px] text-[rgba(0,0,0,0.54)]', 'max-md:min-w-[auto] max-md:text-label-sm')}
          ></div>
          <div
            className={cn('mx-0 my-1 cursor-pointer pl-4 text-[#007db8]', 'max-md:m-0 max-md:pl-0')}
            onClick={(e: React.SyntheticEvent) => onDeleteButtonClick && onDeleteButtonClick(e)}
          >
            <span className="border-b border-solid border-b-[rgba(0,125,184,0.2)]">Удалить</span>
          </div>
        </ListCardRow>
      </ListCardTable>
    </ListCard>
  ) : (
    <ListRow
      onClick={onClick}
      testId={`customer-page--list--${id}`}
      className={cn(
        className,
        'text-sm relative !grid cursor-pointer grid-cols-[40%_1fr_1fr_20px] items-center gap-5 p-0 px-4 py-3 font-normal leading-4 text-[#1a1c1e] shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]',
        'hover:z-[2]',
        'before:pointer-events-none before:absolute before:bottom-full before:left-0 before:h-1.5 before:w-full before:bg-[0_6px] before:bg-no-repeat before:content-[""]',
        'after:pointer-events-none after:absolute after:left-0 after:top-full after:h-2 after:w-full after:bg-[0_-8px] after:bg-no-repeat after:content-[""]',
        'hover:after:[background:linear-gradient(to_top,transparent,rgba(0,0,0,0.06))_0_0]',
        'hover:before:[background:linear-gradient(transparent,rgba(0,0,0,0.06))_0_0]',
        'max-md:flex-col max-md:items-start max-md:p-4 max-md:[border:none]'
      )}
    >
      <div className={cn('flex min-h-[24px] items-center', 'max-2md:font-medium')}>{name || '—'}</div>
      <div className={cn('flex min-h-[24px] items-center')}>{inn || '—'}</div>
      <div className={cn('flex min-h-[24px] items-center')}>{kpp || '—'}</div>
      <div className={cn('flex w-full items-center justify-end')}>{deleteButton}</div>
    </ListRow>
  )
})
